<template>
  <div class="form-row pb-2">
    <div class="col-3 pl-0">
      <select v-model="tipo" class="form-control">
        <option value="0" disabled selected>Selecciona una opción</option>
        <option
          v-for="(item, index) in fields"
          :value="item.field"
          :key="index"
        >
          {{ item.nombre }}
        </option>
      </select>
    </div>
    <div v-if="tipo == 'trabajador_id'" class="col">
      <Treeselect
        placeholder="Trabajador ..."
        :options="trabajadores"
        :searchable="true"
        :clearable="false"
        :open-on-click="true"
        :open-on-focus="true"
        :append-to-body="true"
        v-model="value"
      />
    </div>
    <div v-if="tipo == 'actividad_id'" class="col">
      <Treeselect
        placeholder="Actividad ..."
        :options="actividades"
        :searchable="true"
        :clearable="false"
        :open-on-click="true"
        :open-on-focus="true"
        :append-to-body="true"
        :disable-branch-nodes="true"
        v-model="value"
      />
    </div>
    <div v-if="tipo == 'ubicaciones'" class="col">
      <Treeselect
        placeholder="Ubicación ..."
        :options="ubicaciones"
        :multiple="true"
        :clearable="false"
        :append-to-body="true"
        :open-on-focus="true"
        :open-on-click="true"
        v-model="value"
      />
    </div>
    <div v-if="tipo == 'ubicacion_raiz_id'" class="col">
      <Treeselect
        placeholder="Ubicacion raiz ..."
        :options="ubicacionesRaiz"
        :searchable="true"
        :clearable="false"
        :open-on-click="true"
        :open-on-focus="true"
        v-model="value"
      />
    </div>
    <div v-if="tipo == 'cultivo_id'" class="col">
      <Treeselect
        placeholder="Cultivos ..."
        :options="cultivos"
        :searchable="true"
        :clearable="false"
        :open-on-click="true"
        :open-on-focus="true"
        :append-to-body="true"
        v-model="value"
      />
    </div>
    <div v-if="tipo == 'cultivo_id'" class="col">
      <Treeselect
        placeholder="Embalajes ..."
        :options="embalajes(value)"
        :searchable="true"
        :clearable="false"
        :open-on-click="true"
        :open-on-focus="true"
        :append-to-body="true"
        v-model="embalaje"
      />
    </div>
    <div v-if="tipo == 'cantidad'" class="col">
      <input type="number" class="form-control" min="1" v-model="value" />
    </div>
    <div v-if="tipo == 'cantidad_costo'" class="col">
      <input type="number" class="form-control" min="1" v-model="value" />
    </div>
    <div class="col-auto" v-if="tipo != '0'">
      <button type="button" class="btn btn-primary" @click="aplicar">
        Aplicar
      </button>
    </div>
  </div>
</template>

<script>
import Treeselect from "@riophae/vue-treeselect";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";

export default {
  name: "Masivo",
  props: [
    "selection",
    "fields",
    "trabajadores",
    "actividades",
    "ubicacionesRaiz",
    "ubicaciones",
    "cultivos",
  ],
  components: {
    Treeselect,
  },
  data() {
    return {
      tipo: "0",
      value: null,
      embalaje: null,
    };
  },
  methods: {
    aplicar() {
      for (let i of this.selection) {
        i[this.tipo] = this.value;
      }
      this.value = null;

      if (this.embalaje != null) {
        for (let i of this.selection) {
          i.embalaje = this.embalaje;
        }
      }
      this.embalaje = null;

      this.$emit("update-all");
    },
    embalajes(cultivo_id) {
      let cultivo = this.cultivos.find((element) => element.id == cultivo_id);
      if (cultivo) {
        return cultivo.embalajes.map((item, index) => {
          return {
            id: item.nombre,
            label: item.nombre,
          };
        });
      }
      return [];
    },
  },
};
</script>
